import { WbIdOauthBrowserSdk, Environment } from '@wb-id/oauth-browser-sdk'
import nookies from 'nookies'
import { GetServerSidePropsContext } from 'next'

const getClientId = () => {
  return process.env.NEXT_PUBLIC_WB_OAUTH_CLIENT_ID || ''
}

const getEnvironment = (): Environment => {
  return Environment.PROD
}

const getRedirectUri = (context?: GetServerSidePropsContext) => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname
    if (hostname === 'localhost' || hostname.includes('dev.sellmonitor.com')) {
      return 'https://dev.sellmonitor.com/oauth/start/wb/callback/'
    }
    return 'https://sellmonitor.com/oauth/start/wb/callback/'
  }
  if (context) {
    const host = context.req?.headers.host || ''
    if (host.includes('localhost') || host.includes('dev.sellmonitor.com')) {
      return 'https://dev.sellmonitor.com/oauth/start/wb/callback/'
    }
    return 'https://sellmonitor.com/oauth/start/wb/callback/'
  }
  return 'https://sellmonitor.com/oauth/start/wb/callback/'
}

export const createWbIdSdk = (context?: GetServerSidePropsContext) => {
  const clientId = getClientId()
  const environment = getEnvironment()
  const redirectUri = getRedirectUri(context)

  const getCookie = async (cookieName: string): Promise<string | undefined> => {
    if (context) {
      const cookies = nookies.get(context)
      return cookies[cookieName]
    }
    if (typeof document !== 'undefined') {
      const cookies = document.cookie.split('; ')
      const cookie = cookies.find((c) => c.startsWith(`${cookieName}=`))
      return cookie ? cookie.split('=')[1] : undefined
    }
    return undefined
  }

  return new WbIdOauthBrowserSdk({
    clientId,
    scope: 'openid phone',
    redirectUri,
    environment,
    getCookie,
    endpoints: {
      authorize: '/api/next/oauth-bff/api/v1/authorize',
      token: '/api/next/oauth-bff/api/v1/token',
      user: '/api/next/oauth-bff/api/v1/user-info',
      revoke: '/api/next/oauth-bff/api/v1/revoke',
    },
  })
}
